var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/InfiniteScrollTrigger/index.tsx";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * @file A controlled component that triggers loading for infinite scroll
 * behaviour.
 *
 * Should be instantiated positionally at the bottom of a list whose next load
 * should be triggered as the user scrolls to the bottom of the list.
 *
 * Implemented using the IntersectionObserver web API for optimal performance.
 */

import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@wds/button';
import { Box } from '@wds/box';
import { ProgressCircle } from '@wds/progress-circle';
import { T, t } from '@sm/intl';
var COPY = {
  // todo: add in definemessages when translating
  LOAD_MORE: {
    id: 'InfiniteScrollTrigger.LoadMore',
    defaultMessage: 'Load more',
    description: '[Type: button][Vis: med] - Button to load more data'
  },
  LOADING: {
    id: 'InfiniteScrollTrigger.Loading',
    defaultMessage: 'Loading...',
    description: '[Type: button][Vis: low] - loading data'
  }
};
var useIntersectionObserverCallback = function useIntersectionObserverCallback(callback) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$root = options.root,
    root = _options$root === void 0 ? null : _options$root,
    rootMargin = options.rootMargin,
    _options$threshold = options.threshold,
    threshold = _options$threshold === void 0 ? 0 : _options$threshold;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    node = _useState2[0],
    setNode = _useState2[1];
  var observer = useRef(null);
  useEffect(function () {
    if (observer.current) {
      observer.current.disconnect();
    }
    if (window.IntersectionObserver) {
      observer.current = new window.IntersectionObserver(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          newEntry = _ref2[0];
        return callback(newEntry);
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold
      });
    }
    if (node) {
      var _observer$current;
      (_observer$current = observer.current) === null || _observer$current === void 0 ? void 0 : _observer$current.observe(node);
    }
    return function () {
      var _observer$current2;
      return (_observer$current2 = observer.current) === null || _observer$current2 === void 0 ? void 0 : _observer$current2.disconnect();
    };
  }, [callback, node, root, rootMargin, threshold]);
  return [!!window.IntersectionObserver, setNode];
};
function InfiniteScrollTrigger(_ref3) {
  var hasMoreToLoad = _ref3.hasMoreToLoad,
    loadingFirstData = _ref3.loadingFirstData,
    loadingMore = _ref3.loadingMore,
    onLoadMore = _ref3.onLoadMore;
  var _useIntersectionObser = useIntersectionObserverCallback(function (entry) {
      if (entry.isIntersecting) {
        onLoadMore();
      }
    }, {}),
    _useIntersectionObser2 = _slicedToArray(_useIntersectionObser, 2),
    isSupported = _useIntersectionObser2[0],
    ref = _useIntersectionObser2[1];
  return loadingMore && !loadingFirstData ? /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexJustify: "center",
    mt: 4,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 125,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(ProgressCircle, {
    continuous: true,
    size: "sm",
    "data-testid": "InfiniteScrollTrigger__Loading",
    valueText: t(COPY.LOADING),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 126,
      columnNumber: 11
    }
  })) : hasMoreToLoad && isSupported ? /*#__PURE__*/React.createElement(Box, {
    mt: 4,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 135,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 136,
      columnNumber: 11
    }
  })) : hasMoreToLoad && !isSupported ? /*#__PURE__*/React.createElement(Box, {
    flexAlign: "center",
    mt: 4,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 140,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Button, {
    color: "muted",
    size: "sm",
    onClick: onLoadMore,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 141,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.LOAD_MORE,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 142,
      columnNumber: 13
    }
  }))) : null;
}
InfiniteScrollTrigger.propTypes = {
  hasMoreToLoad: PropTypes.bool.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  loadingFirstData: PropTypes.bool.isRequired,
  loadingMore: PropTypes.bool.isRequired
};
export default InfiniteScrollTrigger;
//# sourceMappingURL=index.js.map